import { render, staticRenderFns } from "./ParticipantInfoCard.vue?vue&type=template&id=88cc61ac&scoped=true"
import script from "./ParticipantInfoCard.vue?vue&type=script&lang=js"
export * from "./ParticipantInfoCard.vue?vue&type=script&lang=js"
import style0 from "./ParticipantInfoCard.vue?vue&type=style&index=0&id=88cc61ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88cc61ac",
  null
  
)

export default component.exports